import { createSlice, current } from '@reduxjs/toolkit'

const initialState = {
    auxiliarIndex: 0,
    newSchools: [],
    schoolFormsStorage: [],
    editForm: false
}
export const schoolSlice = createSlice({
    name: 'school',
    initialState,
    reducers: {
        setAuxiliarIndex: (state, action) => {
            return {
                ...state,
                auxiliarIndex: state.auxiliarIndex + 1
            }
        },
        addNewSchoolStorage: (state, action) => {
            state.newSchools = [...state.newSchools, action.payload]
        },
        removeSchoolStorage: (state, action) => {
            state.newSchools = state.newSchools.filter((_, index) => index !== action.payload)
        },
        setNewSchools: (state, action) => {
            state.newSchools = action.payload
        },
        updateNewSchools: (state, action) => {
            state.newSchools = action.payload
        },
        setSchoolFormsStorage: (state, action) => {
            state.schoolFormsStorage = action.payload
        },
        addNewSchoolFormStorage: (state, action) => {
            state.schoolFormsStorage = [...state.schoolFormsStorage, action.payload]
        },
        setEditForm: (state, action) => {
            state.editForm = action.payload
        },
        resetStateSchools: () => initialState
    }
})

export const {
    setAuxiliarIndex,
    addNewSchoolStorage,
    removeSchoolStorage,
    setNewSchools,
    updateNewSchools,
    setSchoolFormsStorage,
    addNewSchoolFormStorage,
    setEditForm,
    resetStateSchools
} = schoolSlice.actions
export default schoolSlice.reducer
